// extracted by mini-css-extract-plugin
export default {"container":"RobotMarker_container__p1tdH","header":"RobotMarker_header__EB9P6","line":"RobotMarker_line__+84Ur","arrow":"RobotMarker_arrow__BeDeu"};